import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { lessonStructure } from '../../data/content';
export function LessonSection() {
  const half = Math.ceil(lessonStructure.length / 2);
  const columns = [lessonStructure.slice(0, half), lessonStructure.slice(half)];
  return <section aria-labelledby="lesson-heading" className="bg-brand-blush px-5 py-16 lg:px-8 lg:py-24" data-id="element-132" data-mp="3m9sy1n73avd9">
      <div className="mx-auto max-w-5xl" data-id="element-133" data-mp="muntlxilda6g">
        <SectionHeading id="lesson-heading" eyebrow="Ready to Teach" title={<>
              Open a Lesson. Follow the Structure. <Accent data-id="element-135" data-mp="dsobt2zr622g">Start Teaching.</Accent>
            </>} body="Each lesson is designed around the information an educator actually needs when preparing and delivering a class." data-id="element-134" data-mp="mtm9z4niffd4" />

        <div className="mt-14 rounded-[20px] bg-white px-6 py-8 shadow-[0_30px_60px_-40px_rgba(120,70,80,0.45)] sm:px-10 sm:py-10" data-id="element-136" data-mp="2ykq4bgz6lc2e">
          <div className="grid gap-x-14 md:grid-cols-2" data-id="element-137" data-mp="2tjan6004jppa">
            {columns.map((column, columnIndex) => <ol key={columnIndex} start={columnIndex * half + 1} className={columnIndex === 1 ? 'border-t border-brand-charcoal/10 md:border-t-0' : ''} data-id="element-138" data-mp="297a4e88zrmj5" data-mpi={columnIndex}>
                {column.map(step => <li key={step.number} className="flex items-start gap-4 border-b border-brand-charcoal/10 py-4 last:border-b-0 md:last:border-b-0" data-id="element-139" data-mp="257hpldt08k5c">
                    <span className="w-8 flex-none pt-1 font-display text-[1.35rem] font-bold leading-none text-brand-gold" data-id="element-140" data-mp="1qhtrelg4e1lu">
                      {step.number}
                    </span>
                    <span data-id="element-141" data-mp="1hiyih1loydeu">
                      <span className="block font-body text-[13px] font-semibold uppercase tracking-[0.1em] text-brand-charcoal" data-id="element-142" data-mp="1hjrryac1bh0o">
                        {step.title}
                      </span>
                      <span className="mt-1 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-143" data-mp="17kj2nus46qkn">
                        {step.description}
                      </span>
                    </span>
                  </li>)}
              </ol>)}
          </div>
        </div>
      </div>
    </section>;
}